export const TAX = 'TAX';
export const CHECKING = 'CHECKING';
export const PAYSTUB = 'PAYSTUB';
export const ASSET = 'ASSET';
export const OPENER = 'OPENER';

export const POINTSERV_TAX = 'POINTSERV_TAX';
export const POINTSERV_PAYSTUB = 'POINTSERV_PAYSTUB';
export const MANUAL_PAYSTUB = 'MANUAL_PAYSTUB';
export const PLAID_CHECKING = 'PLAID_CHECKING';
export const PLAID_ASSETS = 'PLAID_ASSETS';
export const TRUEWORK_PAYSTUB = 'TRUEWORK_PAYSTUB';

export const properties = {
  TAX: {
    description: 'Tax Returns',
    message:
      'Log in to your tax preparation service or IRS.gov to provide us your gross income in a few simple steps.',
  },
  CHECKING: {
    description: 'Checking Account',
    message:
      'Log in to your financial institution to securely link your personal checking account. Business accounts are not eligible.',
  },
  PAYSTUB: {
    description: 'Paystubs',
    message: 'Log in to your payroll provider to provide us with your most recent paystub.',
  },
  ASSET: {
    description: 'Asset Accounts',
    message:
      'Log in to your asset accounts. This can include retirement, savings, and investment accounts.',
  },
};

export const DISABLED_INCOME_SOURCES_MAP = {
  MANUAL_PAYSTUB,
  POINTSERV_TAX: TAX,
  POINTSERV_PAYSTUB: PAYSTUB,
  PLAID_CHECKING: CHECKING,
  PLAID_ASSETS: ASSET,
};
